import React from 'react';
import { graphql } from 'gatsby';
import SEO from 'components/SEO';
import H1 from 'components/H1';
import { Box, Flex, Container } from 'components/Grid';
import Image from 'components/Image';
import Paragraph from 'components/Paragraph';
import RichText from 'components/RichText';

const SinglePostTemplate = ({ data }) => {
	const { featuredImage, headline, content, type, seoDescription, createdAt, optionalDate } = data.contentfulPost;
	
	return (
		<div>
			<SEO title={headline} image={featuredImage.file && featuredImage.file.url} description={seoDescription && seoDescription.internal.content} keywords={[`gatsby`, `application`, `react`]} />
			<Container py={[0, 0, 0]}>
				<Flex>{featuredImage && <Image fluid={featuredImage.fluid} />}</Flex>
			</Container>
			<Container>
				<Flex justifyContent="center">
					<Box textAlign="center" width={[1, 3 / 4]}>
						<H1 color="client.primary">{headline}</H1>
						<Paragraph mb={[0]}>
							{type}, {optionalDate || createdAt}
						</Paragraph>
					</Box>
				</Flex>
				<Flex py={[4, 6]} justifyContent="center">
					<Box width={[1, 2 / 3]}>
						<RichText json={content.json} />
					</Box>
				</Flex>
			</Container>
		</div>
	);
};

export const pageQuery = graphql`
	query PostBySlug($slug: String) {
		contentfulPost(slug: { eq: $slug }) {
			headline
			optionalDate(formatString: "d MMMM YYYY", locale: "sv-SE")
			createdAt(formatString: "d MMMM YYYY", locale: "sv-SE")
			type
			featuredImage {
				fluid(quality: 100, maxWidth: 4000) {
					...GatsbyContentfulFluid
				}
				file {
					url
				}
			}
			seoDescription {
				internal {
					content
				}
			}
			content {
				json
				content
				
			}
		}
	}
`;

export default SinglePostTemplate;
